export const strings = {
    "ro_lang": "Română",
    "ru_lang": "Русский",
    "iban":"IBAN",
    "email_example": "example@email.com",
    "mpass": "MPass",
    "doc_name":'Contract eCredit {{urn}}.pdf'
}